import React, { useEffect, useLayoutEffect, useState } from 'react';
import styles from './CommingSoon.module.scss';
import getCookie from '../../../app/helpers/getCookie';
import Text from '../../atoms/text/Text';
const historySvg = '/icons/history/history-circle.svg';

import { useLocation } from 'react-router-dom';
const ComingSoonContainer = ({ isGreen, contStyle }) => {
  const location = useLocation();
  const [isEnglish, setIsEnglish] = useState(false);

  useLayoutEffect(() => {
    if (location.pathname === '/coming-soon') window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const cookieVal = getCookie('googtrans');
    if (cookieVal?.includes('/ar/en') || cookieVal?.includes('/ar/en')) {
      setIsEnglish(true);
    }
  }, []);

  return (
    <div className={styles.commingSoonContainer} style={contStyle}>
      <div className={styles.subContainer}>
        {/* <Text
            title={isEnglish ? 'Coming Soon' : 'common.soon'}
            className={styles.text}
            color="white"
          /> */}
        <div className={styles['comingSoon-svg']}>
          <img
            src={historySvg}
            className={`${isGreen ? styles.greenFilter : ''}`}
          />
          <div className={styles['text-container']}>
            <Text
              title={isEnglish ? 'Coming Soon' : 'common.soon'}
              variant="text-regular-bold-40"
              className={`${styles.comingSoonText} ${isGreen ? styles.greenText : ''}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonContainer;
